module.exports = __webpack_public_path__ + "img/icon_cat_serial.3cb77b2.png";